import { image_thumbnail_edits } from '$tablet-app/src/app/images/data/image_size_edits';

export const recipe_tile_image_edits = {
  resize: {
    width: 400,
    height: 300,
    fit: 'cover',
  },
};

export const recipe_thumbnail_image_edits = image_thumbnail_edits;
